import { FlexColumn, FlexRow } from '@editor/components/utilities/layouts';
import { H6, P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const CreditsBalanceBannerContainer = styled(FlexRow)`
  background-color: ${themeStyle.varInkSuperLight};
  padding: 12px;
  align-items: center;
  justify-content: space-between;
  border-radius: ${themeStyle.radiusMedium};
`;

export const InfoIconWrapper = styled.div`
  rotate: 180deg;
`;

export const CreditsBalanceBannerWrapper = styled(FlexColumn)`
  background-color: ${themeStyle.varInkSuperLight};
  border-radius: 0 0 ${themeStyle.radiusMedium} ${themeStyle.radiusMedium};
  padding: 0 12px 12px 12px;
`;

export const ClosePanelIconWrapper = styled(FlexColumn)<{ isOpen: boolean }>`
  transform: rotate(${({ isOpen }) => (isOpen ? '0' : '180deg')});
  transition: transform 0.3s ease-in-out;
`;

export const CreditsBalanceInfoContainer = styled(FlexColumn)`
  gap: 12px;
`;
export const CreditsBalanceInfoWrapper = styled(FlexColumn)`
  width: 100%;
  gap: 4px;
`;

export const CreditsBalanceInfoRowBox = styled(FlexColumn)`
  padding: 8px 0;
  width: 100%;
  gap: 2px;
`;

export const CreditsBalanceInfoRow = styled(FlexRow)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  & ${P3} {
    line-height: 18px;
  }
`;

export const CreditsBalanceInfoRowLeft = styled(FlexRow)`
  & ${H6} {
    font-weight: 500;
    line-height: 16px;
  }
`;
